module.exports = __webpack_public_path__ + "static/img/history.26baa29.svg";